// extracted by mini-css-extract-plugin
export default {"space":"styles_space__Lwkqy","xs":"styles_xs__aIszA","sm":"styles_sm__efkYc","md":"styles_md__+WAIn","lg":"styles_lg__t3iKV","xl":"styles_xl__bJ8HG"};